'use client';

import { useCallback } from 'react';
import { createClientLogger, logClientError } from '@/client/logging/client-logger';
import { useAuth } from '@/context/auth.context';
import { useClientFeatureControls } from '@/context/client-feature-controls.context';
import { useMarketplaceApi } from '@/context/marketplace.context';
import { normalizeClientSettingsEntity } from '@/shared/client-settings';

const quotaRefreshLogger = createClientLogger({
    scope: 'client-ai-quota-refresh',
});

export const useRefreshClientAiQuota = () => {
    const { accessToken } = useAuth();
    const { settingsApi } = useMarketplaceApi();
    const { setAiQuota, setFeatureControls } = useClientFeatureControls();

    return useCallback(async () => {
        try {
            const response = await settingsApi.get({ authToken: accessToken });
            const normalizedSettings = normalizeClientSettingsEntity(response.data);
            setAiQuota(normalizedSettings.aiQuota);
            setFeatureControls(normalizedSettings.featureControls);
            return normalizedSettings.aiQuota;
        } catch (error) {
            logClientError({
                logger: quotaRefreshLogger,
                message: '[client.ai-quota.refresh] Failed to refresh AI quota availability.',
                error,
            });
            return null;
        }
    }, [accessToken, setAiQuota, setFeatureControls, settingsApi]);
};
